/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import useTablePart from '../../../BasicEditor/hook/tablepart';
import WorkExpirienceHeader from './header';
import WorkExpirienceRow from './row';

function WorkExpiriences({
  positions, onChange, data, fields, errors,
}) {
  const {
    tableData, tableActions,
    tableContainerRef, tableErrors,
    tableFields,
  } = useTablePart({
    data, onChange, tableName: 'work_experiences', errors, fields,
  });
  return (
    <Card className="border-0 ">
      <Card.Header>
        <WorkExpirienceHeader fields={tableFields} />
      </Card.Header>
      <Card.Body className="p-0" ref={tableContainerRef}>
        {tableData.map((row, rowIndex) => (
          <WorkExpirienceRow
            row={row}
            key={rowIndex}
            errors={tableErrors[rowIndex]}
            positions={positions}
            fields={tableFields}
            onChange={tableActions.onCellChange}
            onDeleteRow={tableActions.onDeleteRow}
            index={rowIndex}
          />
        ))}
      </Card.Body>
      <Card.Footer>
        <Button variant="outline-primary" onClick={() => tableActions.onAddRow()}>
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Add work expirience
        </Button>
      </Card.Footer>
    </Card>
  );
}

WorkExpiriences.propTypes = {
  data: PropTypes.shape({
  }),
  positions: PropTypes.shape({
    selectorValues: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

WorkExpiriences.defaultProps = {
  data: [],
};

export default WorkExpiriences;
